// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/CartItem2/style.css
// module id = 1771
// module chunks = 0